import { BaseEntityDtoAny } from "@/common/ts/entity";

import TableCellContentOfAffiliation from "./TableCellContentOfAffiliation";

interface Props {
  entity: Nil<BaseEntityDtoAny>;
}

export default function TableCellContentOfAffiliationInLocations({ entity }: Props) {
  return (
    <TableCellContentOfAffiliation
      entity={entity}
      displayProps={{
        tenant: false,
        departments: false,
        locations: true,
      }}
    />
  );
}
